import React, { useEffect, useState } from "react";
import { Pagination } from "antd";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import moment from "moment-jalaali";
import { Skeleton } from "antd";
import { useOutletContext } from 'react-router-dom';

const NotificationList = () => {
    const [notifications, setNotifications] = useState([]);
    const [notificationsCount, setNotificationsCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortColumn, setSortColumn] = useState("updatedAt");
    const [sortDir, setSortDir] = useState("desc");
    const [filterDateFrom, setFilterDateFrom] = useState(null);
    const [filterDateTo, setFilterDateTo] = useState(null);
    const [pageSize] = useState(10);
    const { refreshNotifs } = useOutletContext();

    const GETNOTIFS = gql`
      query getAdminMessages($paginateInput: PaginateInput!) {
       getAdminMessagesCount
         getAdminMessages(paginateInput: $paginateInput){
            id
            createdAt
            updatedAt
            title
            body   
            userIds
            isActive
            type
         }
      }
    `;
    const MARKMESSAGESSEEN = gql`
            mutation markMessageAsRead($messageIds: [ID!]!) {
            markMessageAsRead(messageIds: $messageIds)
            }
      `;
    const [getNotifs, notifs] = useLazyQuery(GETNOTIFS, {
        fetchPolicy: "no-cache",
        onCompleted({ getAdminMessages, getAdminMessagesCount }) {
            setNotifications(getAdminMessages);
            setNotificationsCount(getAdminMessagesCount);
        },
    });

    useEffect(() => {
        getNotifs({
            variables: {
                paginateInput: {
                    page: currentPage,
                    perPage: pageSize,
                    sort: sortColumn && sortColumn,
                    sortDir: sortDir,
                },
            }
        })
    }, [currentPage, sortDir, filterDateTo]);


    const [runMarkSeen, markSeen] = useMutation(MARKMESSAGESSEEN, {
        refetchQueries: [
            'getUnreadAdminMessagesCount'
        ],
        onCompleted({ markMessageAsRead }) {
            console.log("messages marked seen", markMessageAsRead);
            refreshNotifs()
        },
    });
    useEffect(() => {
        const messageIds = notifications?.map(n => n.id) || [];
        if (messageIds.length) {
            runMarkSeen({
                variables: {
                    messageIds
                }
            })
        }
    }, [notifications]);


    const pageChange = (current) => {
        setCurrentPage(current);
    };

    const sort = (sortData) => {
        setCurrentPage(1);
        setSortColumn(sortData.columnKey);
        if (sortData.order === "ascend") setSortDir("asc");
        if (!sortData.order || sortData.order === "descend") setSortDir("desc");
    };

    const filterDate = (dates, dateString) => {
        setCurrentPage(1);
        if (dateString[0] === "" || dateString[1] === "") {
            setFilterDateFrom(null);
            setFilterDateTo(null);
        } else {
            setFilterDateFrom(
                moment(dateString[0], "jYYYY/jMM/jDD")
                    .startOf("day")
                    .toDate()
                    .toISOString()
            );
            setFilterDateTo(
                moment(dateString[1], "jYYYY/jMM/jDD")
                    .endOf("day")
                    .toDate()
                    .toISOString()
            );
        }
    };

    if (notifs.loading) {
        <>
            <Skeleton active round />
            <br />
            <Skeleton active round />
        </>
    }
    return (
        <div className="notification-container">
            <div className="notification-header">
                <h3>پیام های ادمین: </h3>
            </div>
            {
                notifications.length ?
                    <div className="notification-list">
                        {notifications?.map((notif) => (
                            <div key={notif?.id} className="notification-item">
                                <div className="notification-icon">🔔</div>

                                <div className="notification-content">
                                    <div className="notification-title">{notif?.title}</div>
                                    {/* <div className="notification-body">{notif?.body}</div> */}
                                    <div
                                        dangerouslySetInnerHTML={{ __html: notif?.body }}
                                        style={{ margin: "30px" }}
                                    ></div>
                                    {notif?.updatedAt ? <div className="notification-time">
                                        {moment(notif?.updatedAt).format("jYYYY/jMM/jDD")}
                                    </div> : null}
                                </div>
                            </div>
                        ))}

                    </div> : <div>
                        <div className="notification-empty">No notifications yet</div>
                    </div>
            }

            <div className="notification-pagination">
                <Pagination
                    current={currentPage}
                    total={notificationsCount}
                    pageSize={pageSize}
                    onChange={pageChange}
                    showSizeChanger={false}
                />
            </div>
        </div>
    );
}


export default NotificationList;
